import { STORAGE_KEYS } from '@/constants/app';

function emptyValue(value) {
    return (!value || typeof value === 'undefined' || value === '' || value === 'null') && !(value === 0);
}

function hasObjectValue(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }
    return Object.keys(obj).some((key) => {
        const value = obj[key];
        if (Array.isArray(value)) {
            return value.length > 0;
        }
        return !emptyValue(value);
    });
}

export function isSafeRedirectPath(path) {
    return typeof path === 'string' && path.startsWith('/') && !path.startsWith('//');
}

export function hasRouteParams(route) {
    return hasObjectValue(route?.query) || hasObjectValue(route?.params);
}

export function getLoginRedirectPath(route) {
    if (!route || route.path === '/' || !isSafeRedirectPath(route.path) || hasRouteParams(route)) {
        return '';
    }
    const redirect = route.fullPath || route.path;
    return isSafeRedirectPath(redirect) ? redirect : '';
}

export function rememberLoginRedirect(route) {
    const redirect = getLoginRedirectPath(route);
    if (emptyValue(redirect)) {
        sessionStorage.removeItem(STORAGE_KEYS.redirectPath);
        return '';
    }
    sessionStorage[STORAGE_KEYS.redirectPath] = redirect;
    return redirect;
}

export function rememberCurrentLoginRedirect(route) {
    const routeRedirect = getLoginRedirectPath(route);
    if (!emptyValue(routeRedirect)) {
        sessionStorage[STORAGE_KEYS.redirectPath] = routeRedirect;
        return routeRedirect;
    }
    if (route && hasRouteParams(route)) {
        sessionStorage.removeItem(STORAGE_KEYS.redirectPath);
        return '';
    }

    const path = window.location.pathname;
    if (!isSafeRedirectPath(path) || path === '/' || window.location.search) {
        sessionStorage.removeItem(STORAGE_KEYS.redirectPath);
        return '';
    }

    const redirect = `${path}${window.location.hash || ''}`;
    sessionStorage[STORAGE_KEYS.redirectPath] = redirect;
    return redirect;
}

export function consumeLoginRedirect() {
    const redirect = sessionStorage[STORAGE_KEYS.redirectPath];
    sessionStorage.removeItem(STORAGE_KEYS.redirectPath);
    return isSafeRedirectPath(redirect) ? redirect : '';
}
